<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="zh"></div>
      <div class="border-box">
        <div class="hood-title">户外招牌设施设置规范管理</div>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="form.idCard" placeholder="身份证号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="招牌名称" prop="storeName">
                <el-input v-model="form.storeName" placeholder="招牌名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="hood-title"><span class="tips">规 格</span></div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="长(厘米)" prop="shopSpecHeight">
                <el-input v-model="form.shopSpecHeight" placeholder="长(厘米)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="宽(厘米)" prop="shopSpecWeight">
                <el-input v-model="form.shopSpecWeight" placeholder="宽(厘米)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="面积(㎡)">
                <el-input v-model="shopSpec" placeholder="面积(㎡)"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="所属街道" prop="isChange">
                <el-select v-model="form.isChange" placeholder="请选择所属街道">
                  <el-option v-for="item in streetList" :key="item.code" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="您的店铺位置" prop="address">
                <el-input v-model="form.address" placeholder="您的店铺位置(此处须填写到XX街道办事处XX街（路）XX号)"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="您是否了解《潍坊市户外广告和招牌设置管理办法》" label-width="auto" prop="know">
                <el-radio-group v-model="form.know">
                  <el-radio-button label="0">了解</el-radio-button>
                  <el-radio-button label="1">不了解</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <el-form-item label="上传文件">
                <el-button type="primary" @click="generateQrcode">上传文件</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="二维码">
                <canvas id="qrCode" class="code-img"></canvas>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="td"></div>
    </div>
    <Back @toBack="toBack" :print="3" @toSubmit="checkSubmit" />
  </div>
</template>
<script>
import streetList from "@/assets/js/people/streetList.js";
import { v4 as uuidv4 } from "uuid";
import QRCode from "qrcode";
export default {
  name: '',
  data() {
    return {
      //
      uuid: "",
      form: {
        name: "",//姓名
        phone: "",//手机号
        idCard: "",//身份证
        storeName: "",//店铺名
        address: "",//地址
        know: "",//是否知晓
        isChange: "",//所属街道
        shopSpecHeight: "", //长
        shopSpecWeight: "", //宽
        positionPhoto: "",
        daytimePhoto: "",
        nightPhoto: "",
        idCardPhoto: "",
        businessLicense: "",
        contractPhoto: "",
      },
      loading: null,
      streetList: [],//街道列表
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ],
        storeName: [
          { required: true, message: '请输入招牌名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入店铺位置', trigger: 'blur' },
        ],
        know: [
          { required: true, message: '请选择是否了解', trigger: 'change' },
        ],
        isChange: [
          { required: true, message: '请选择所属街道', trigger: 'change' },
        ],
        shopSpecHeight: [
          { required: true, message: '请输入招牌长度', trigger: 'blur' },
        ],
        shopSpecWeight: [
          { required: true, message: '请输入招牌宽度', trigger: 'blur' },
        ],
      }
    };
  },
  created() {
    //
    this.streetList = streetList //街道
    this.uuid = uuidv4().replaceAll("-", "");
    // this.uuid = '123456789'
  },
  computed: {
    shopSpec: {
      get() {
        var h, w
        if (this.form.shopSpecHeight == '') {
          h = 0
        } else {
          h = Number(this.form.shopSpecHeight) / 100
        }
        if (this.form.shopSpecWeight == '') {
          w = 0
        } else {
          w = Number(this.form.shopSpecWeight) / 100
        }
        return (h * w).toFixed(2)
      },
      set(val) { }
    }
  },
  mounted() {
    //
  },
  methods: {
    checkSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.getFileList()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取文件列表
    getFileList() {
      this.loading = this.$loading({
        lock: true,
        text: '正在提交',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$rqt.common_getRecord({
        key: this.uuid
      }).then(res => {
        var list = res.data
        // clog.a('文件列表', list)
        list.forEach(elemetnt => {
          // 正式版本打开
          if (elemetnt.adminTitle == '户外招牌设置') {
            this.setOutdoorsFiles(elemetnt)
          }
        });
      }).catch(err => {
        clog.a('获取文件列表失败', err)
        this.loading.close();
      })
    },
    // 筛选户外广告文件
    setOutdoorsFiles(elemetnt) {
      this.form.positionPhoto = this.setListUrl(elemetnt.list[0].files)
      this.form.daytimePhoto = this.setListUrl(elemetnt.list[1].files)
      this.form.nightPhoto = this.setListUrl(elemetnt.list[2].files)
      this.form.idCardPhoto = this.setListUrl(elemetnt.list[3].files)
      this.form.businessLicense = this.setListUrl(elemetnt.list[4].files)
      this.form.contractPhoto = this.setListUrl(elemetnt.list[5].files)
      clog.a(' 提交完成', this.form)
      this.$rqt.shopSign_insert(this.form).then(res => {
        clog.a('提交完成', res)
        this.loading.close();
        this.$alert('提交成功', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.back();
          }
        });
      }).catch(err => {
        clog.a('提交失败', err)
        this.loading.close();
        this.$alert('提交失败', '温馨提示', {
          confirmButtonText: '确定',
        });
      })
    },
    setListUrl(data) {
      var url = []
      data.forEach(el => {
        url.push(el.url)
      })
      return url.join(',')
    },
    // 生成二维码
    generateQrcode() {
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数 
      // var url = `http://192.168.1.105:8081/#/peopleUploadFiles?type=6&uuid=${this.uuid}&cerno=0&common=0`
      var url = `https://l.zwfwpt.cn/#/peopleUploadFiles?type=6&uuid=${this.uuid}&cerno=0&common=0`
      console.log(url);
      QRCode.toCanvas(
        canvas,
        url,
        function (error) {
          if (error) {
            console.error(error);
          } else {
            console.log("success!");
          }
        }
      );
    },
    toBack() {
      this.$router.back();
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  padding: 0 5rem;
  background-color: #F1FAFC;
  overflow-y: scroll;
  position: relative;
}

.content::-webkit-scrollbar {
  width: 0;
}

.border-box {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}

.hood-title {
  font-size: 5rem;
  font-weight: bold;
  margin-left: 10rem;
  margin-bottom: 5rem;
  text-align: center;

  .tips {
    font-weight: 100;
  }
}

.zh {
  height: 60px;
}

.td {
  height: 35rem;
}
</style>